<div *ngIf="empresa" class="dispositivos-page">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <ol class="breadcrumb m-0" *ngIf="modoSuperadmin">
            <li class="breadcrumb-item"><a routerLink="/superadmin/empresas">Empresas</a></li>
            <li class="breadcrumb-item active">{{empresa.nome}}</li>
          </ol>
          <ol class="breadcrumb m-0" *ngIf="!modoSuperadmin">
            <li class="breadcrumb-item"><a routerLink="/admin/loja">Loja</a></li>
            <li class="breadcrumb-item active">Dispositivos WhatsApp</li>
          </ol>
        </div>
        <h4 class="page-title">
          <button class="btn btn-outline-blue btn-rounded" (click)="voltar()" aria-label="Voltar">
            <i class="fa fa-arrow-left"></i>
          </button>
          <i class="fas fa-desktop titulo-icone"></i>
          <span *ngIf="modoSuperadmin">{{empresa.nome}}</span>
          <span *ngIf="!modoSuperadmin">Dispositivos WhatsApp</span>
        </h4>
      </div>
    </div>
  </div>

  <section class="painel-dispositivos" aria-labelledby="titulo-dispositivos">
    <header class="painel-cabecalho">
      <div>
        <span class="sobretitulo">CONEXÕES DA EXTENSÃO</span>
        <h2 id="titulo-dispositivos">Dispositivos conectados</h2>
        <p>Cada linha representa um navegador conectado à empresa.</p>
      </div>
      <button class="botao-atualizar" (click)="carregue(true)" [disabled]="atualizando">
        <i class="fas fa-sync-alt" [class.fa-spin]="atualizando"></i>
        <span>{{atualizando ? 'Atualizando' : 'Atualizar'}}</span>
      </button>
    </header>

    <div class="resumo-conexoes">
      <div class="resumo-conexao resumo-online">
        <span class="resumo-icone"><i class="fas fa-signal"></i></span>
        <div>
          <strong>{{dispositivos.length}}</strong>
          <span>Dispositivos online</span>
        </div>
      </div>
      <div class="resumo-conexao">
        <span class="resumo-icone"><i class="fab fa-whatsapp"></i></span>
        <div>
          <strong>{{totalNumeros}}</strong>
          <span>Números em operação</span>
        </div>
      </div>
      <div class="resumo-conexao" [class.resumo-enviando]="totalEnviando > 0">
        <span class="resumo-icone"><i class="fas fa-paper-plane"></i></span>
        <div>
          <strong>{{totalEnviando}}</strong>
          <span>Enviando agora</span>
        </div>
      </div>
    </div>

    <div class="barra-filtros" *ngIf="!carregando && (dispositivos.length || busca || filtro !== 'todos')">
      <label class="busca-dispositivo">
        <i class="fas fa-search"></i>
        <input type="search" [(ngModel)]="busca" placeholder="Buscar por dispositivo ou número">
      </label>
      <div class="filtros-estado" aria-label="Filtrar dispositivos por estado">
        <button [class.ativo]="filtro === 'todos'" (click)="filtro = 'todos'">Todos</button>
        <button [class.ativo]="filtro === 'prontos'" (click)="filtro = 'prontos'">Prontos</button>
        <button [class.ativo]="filtro === 'enviando'" (click)="filtro = 'enviando'">Enviando</button>
        <button [class.ativo]="filtro === 'atencao'" (click)="filtro = 'atencao'">
          Atenção <span *ngIf="totalAtencao">{{totalAtencao}}</span>
        </button>
      </div>
    </div>

    <div class="estado-central" *ngIf="carregando">
      <span class="k-i-loading"></span>
      <strong>Consultando os dispositivos...</strong>
    </div>

    <div class="estado-central estado-erro" *ngIf="!carregando && erro">
      <i class="fas fa-exclamation-circle"></i>
      <strong>Não foi possível carregar as conexões</strong>
      <span>{{erro}}</span>
      <button (click)="carregue(true)">Tentar novamente</button>
    </div>

    <div class="estado-central" *ngIf="!carregando && !erro && !dispositivos.length">
      <span class="estado-vazio-icone"><i class="fas fa-plug"></i></span>
      <strong>Nenhum dispositivo conectado</strong>
      <span>Abra o WhatsApp Web com a extensão para o dispositivo aparecer aqui.</span>
    </div>

    <div class="lista-dispositivos" *ngIf="!carregando && !erro && dispositivosFiltrados.length">
      <div class="lista-cabecalho" aria-hidden="true">
        <span>Dispositivo</span>
        <span>Número WhatsApp</span>
        <span>Estado</span>
        <span>Conectado desde</span>
        <span></span>
      </div>

      <article class="dispositivo-linha"
               *ngFor="let dispositivo of dispositivosFiltrados; trackBy: identifiqueSessao"
               [class.com-atencao]="estadoDo(dispositivo) === 'atencao'"
               [class.enviando]="estadoDo(dispositivo) === 'enviando'">
        <div class="dispositivo-principal">
          <span class="indicador-estado" [attr.data-estado]="estadoDo(dispositivo)"></span>
          <span class="icone-dispositivo"><i class="fas fa-desktop"></i></span>
          <div>
            <strong>{{dispositivo.descricaoDispositivo || 'Extensão Chrome'}}</strong>
            <span>ID {{idResumido(dispositivo)}} · versão {{dispositivo.versaoExtensao || 'não informada'}}</span>
          </div>
        </div>

        <div class="dado-linha dado-numero">
          <span class="rotulo-mobile">Número WhatsApp</span>
          <strong><i class="fab fa-whatsapp"></i>{{dispositivo.numero | tel}}</strong>
          <span class="dono-envio" *ngIf="dispositivo.responsavelPelosEnvios">
            <i class="fas fa-check-circle"></i> Responsável pelos envios
          </span>
        </div>

        <div class="dado-linha dado-estado">
          <span class="rotulo-mobile">Estado</span>
          <strong>{{rotuloDoEstado(dispositivo)}}</strong>
          <span>Último sinal {{ultimoSinal(dispositivo)}}</span>
        </div>

        <div class="dado-linha dado-conectado">
          <span class="rotulo-mobile">Conectado desde</span>
          <strong>{{dispositivo.conectadaEm | date:'dd/MM/yyyy'}}</strong>
          <span>{{dispositivo.conectadaEm | date:'HH:mm'}}</span>
        </div>

        <button class="botao-detalhes" (click)="alternarDetalhes(dispositivo)"
                [attr.aria-expanded]="sessaoExpandidaId === dispositivo.sessaoId"
                aria-label="Exibir detalhes técnicos">
          <i class="fas" [ngClass]="sessaoExpandidaId === dispositivo.sessaoId ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </button>

        <div class="detalhes-tecnicos" *ngIf="sessaoExpandidaId === dispositivo.sessaoId">
          <span><strong>ID do dispositivo</strong>{{dispositivo.dispositivoId}}</span>
          <span><strong>ID da sessão</strong>{{dispositivo.sessaoId}}</span>
          <span><strong>WhatsApp Web</strong>{{dispositivo.whatsappConectado ? 'Conectado' : 'Desconectado'}}</span>
          <span><strong>Fila do dispositivo</strong>{{dispositivo.livre ? 'Livre' : 'Ocupada'}}</span>
        </div>
      </article>
    </div>

    <div class="resultado-vazio" *ngIf="!carregando && !erro && dispositivos.length && !dispositivosFiltrados.length">
      Nenhum dispositivo corresponde aos filtros selecionados.
    </div>

    <footer class="painel-rodape" *ngIf="!carregando && !erro">
      <span><i class="fas fa-lock"></i> Para cada número, somente um dispositivo assume os envios.</span>
      <span *ngIf="atualizadoEm">Atualizado às {{atualizadoEm | date:'HH:mm:ss'}}</span>
    </footer>
  </section>
</div>
